import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_448835941 from "../../../../../packages/component/src/components/field/demo/demo1.js?loadDemo";
import legacyImportDemo_3206826806 from "../../../../../packages/component/src/components/field/demo/demo13.js?loadDemo";
import legacyImportDemo_739176678 from "../../../../../packages/component/src/components/field/demo/demo2.js?loadDemo";
import legacyImportDemo_2552418663 from "../../../../../packages/component/src/components/field/demo/demo3.js?loadDemo";
import legacyImportDemo_808633568 from "../../../../../packages/component/src/components/field/demo/demo4.js?loadDemo";
import legacyImportDemo_948646497 from "../../../../../packages/component/src/components/field/demo/demo5.js?loadDemo";
import legacyImportDemo_2010099170 from "../../../../../packages/component/src/components/field/demo/demo6.js?loadDemo";
import legacyImportDemo_706131060 from "../../../../../packages/component/src/components/field/demo/demo11.js?loadDemo";
import legacyImportDemo_198605335 from "../../../../../packages/component/src/components/field/demo/demo12.js?loadDemo";
import legacyImportDemo_3030467683 from "../../../../../packages/component/src/components/field/demo/demo7.js?loadDemo";
import legacyImportDemo_1397213676 from "../../../../../packages/component/src/components/field/demo/demo8.js?loadDemo";
import legacyImportDemo_2564946285 from "../../../../../packages/component/src/components/field/demo/demo9.js?loadDemo";
import legacyImportDemo_1136155477 from "../../../../../packages/component/src/components/field/demo/demo10.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_448835941,
  legacyImportDemo_3206826806,
  legacyImportDemo_739176678,
  legacyImportDemo_2552418663,
  legacyImportDemo_808633568,
  legacyImportDemo_948646497,
  legacyImportDemo_2010099170,
  legacyImportDemo_706131060,
  legacyImportDemo_198605335,
  legacyImportDemo_3030467683,
  legacyImportDemo_1397213676,
  legacyImportDemo_2564946285,
  legacyImportDemo_1136155477,
  React
};